<span class="vertically-center label-with-icon">
    <i class="label-with-icon__icon icon icon-spoon-fork"></i>
    <span class="label">Feeds {{ quantity }}</span>
</span>
